export const useMaintenanceMode = (): boolean => {
  const isMaintenanceMode = import.meta.env.VITE_MAINTENANCE_MODE === 'true'

  return isMaintenanceMode
}
